import { render, staticRenderFns } from "./PlatformStackedChar.vue?vue&type=template&id=0a8dd79c&scoped=true&"
import script from "./PlatformStackedChar.vue?vue&type=script&lang=js&"
export * from "./PlatformStackedChar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8dd79c",
  null
  
)

export default component.exports